/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
*/

(function () {
  function initCollectionSliderArrows() {
    var sliders = document.querySelectorAll(".tabs-collections .tab-content .grid--mobile-slider");
    var arrowHidden = false;

    function hideAllArrows() {
      if (arrowHidden) return;
      arrowHidden = true;

      sliders.forEach(function (slider) {
        slider.classList.remove("show-arrow");
        slider.classList.add("hide-arrow");
      });
    }

    sliders.forEach(function (slider) {
      if (!arrowHidden) {
        slider.classList.add("show-arrow");
      }

      slider.addEventListener("scroll", hideAllArrows, { once: true });

      if (typeof Flickity !== "undefined") {
        var flkty = Flickity.data(slider);
        if (flkty) {
          flkty.on("dragStart", hideAllArrows);
        }
      }
    });
  }

  function initHideSilverOption() {
    function hideSilverOption() {
      document
        .querySelectorAll('.selector-wrapper[data-option-name="choose your option"]')
        .forEach(function (wrapper) {
          var sterlingInput = wrapper.querySelector('input[value="Sterling silver"]');
          var goldVermeilInput = wrapper.querySelector('input[value="Gold vermeil"]');

          var inputToSelect = goldVermeilInput || sterlingInput;

          if (inputToSelect && !inputToSelect.checked && !wrapper.dataset.defaultApplied) {
            wrapper.dataset.defaultApplied = "true";
            inputToSelect.checked = true;
            inputToSelect.dispatchEvent(new Event("change", { bubbles: true }));
          }

          if (sterlingInput) {
            wrapper.style.display = "none";
          }
        });
    }

    hideSilverOption();

    var observer = new MutationObserver(function () {
      hideSilverOption();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initMaterialsTabs() {
    var material1 = document.querySelector('li[data-block-name="Materials-1"]');
    var material2 = document.querySelector('li[data-block-name="Materials-2"]');
    var descriptionTab = document.querySelector('li.tab-link-0');
    var optionInputs = document.querySelectorAll('input[name^="options[Choose your option]"]');

    if (material2) {
      material2.style.display = "none";
    }

    function toggleMaterials() {
      var selected = document.querySelector('input[name^="options[Choose your option]"]:checked');

      if (!selected || !material1 || !material2) return;

      if (selected.value === "Sterling silver" || selected.value === "Gold vermeil") {
        material1.style.display = "";
        material2.style.display = "none";
      } else {
        material1.style.display = "none";
        material2.style.display = "";
      }

      var currentTab = document.querySelector(".product-tabs-title .tab-link.current");

      if (
        currentTab &&
        (
          currentTab.dataset.blockName === "Materials-1" ||
          currentTab.dataset.blockName === "Materials-2"
        ) &&
        descriptionTab
      ) {
        descriptionTab.click();
      }
    }

    function toggleMadeToOrderMessage() {
      var selected = document.querySelector('input[name^="options[Choose your option]"]:checked');
      var message = document.getElementById("made-to-order-message");

      if (!selected || !message) return;

      if (selected.value === "18kt Solid Gold") {
        message.style.display = "block";
      } else {
        message.style.display = "none";
      }
    }

    toggleMaterials();
    toggleMadeToOrderMessage();

    optionInputs.forEach(function (radio) {
      radio.addEventListener("change", toggleMaterials);
      radio.addEventListener("change", toggleMadeToOrderMessage);
    });
  }

  function initSizeSelectionGuard() {
  function setupSizeGuard() {
    var sizeWrappers = document.querySelectorAll('.selector-wrapper[data-option-name="size"], .selector-wrapper[data-option-name="ring size"]');

    Array.from(sizeWrappers).forEach(function (sizeWrapper) {
      if (sizeWrapper.dataset.sizeGuardInitialized === "true") return;
      sizeWrapper.dataset.sizeGuardInitialized = "true";

      var productContainer =
        sizeWrapper.closest(".product-quick-add__content") ||
        sizeWrapper.closest(".product__wrapper") ||
        sizeWrapper.closest(".product-single") ||
        sizeWrapper.closest(".product-page") ||
        sizeWrapper.closest(".product-item") ||
        document;

      var addToCartBtn = productContainer.querySelector("button[data-add-to-cart]");
      var addToCartText = productContainer.querySelector("[data-add-to-cart-text]");
      var sizeRadios = sizeWrapper.querySelectorAll("[data-single-option-selector]");
      var sizeValueLabel = sizeWrapper.querySelector(".radio__legend__value");

      if (!addToCartBtn || !sizeRadios.length) return;

      function hasSelectedSize() {
        return !!sizeWrapper.querySelector("[data-single-option-selector]:checked");
      }

      function setButtonText(text) {
        if (addToCartText) {
          addToCartText.textContent = text;
        }
      }

      function clearSizeDisplay() {
        if (sizeValueLabel) {
          sizeValueLabel.textContent = "";
          sizeValueLabel.style.display = "none";
        }
      }

      function showSizeDisplay(value) {
        if (sizeValueLabel) {
          sizeValueLabel.textContent = value;
          sizeValueLabel.style.display = "inline";
        }
      }

      function setButtonDisabledState(disabled) {
        if (disabled) {
          addToCartBtn.classList.add("disabled");
          addToCartBtn.style.opacity = "0.5";
          addToCartBtn.style.cursor = "not-allowed";
          addToCartBtn.style.pointerEvents = "none";
        } else {
          addToCartBtn.classList.remove("disabled");
          addToCartBtn.style.opacity = "";
          addToCartBtn.style.cursor = "";
          addToCartBtn.style.pointerEvents = "";
        }
      }

      function updateButtonState() {
        var selectedSize = sizeWrapper.querySelector("[data-single-option-selector]:checked");

        if (selectedSize) {
          setButtonDisabledState(false);
          setButtonText("Add to Basket");
          showSizeDisplay(selectedSize.value);
        } else {
          setButtonDisabledState(true);
          setButtonText("Select a size");
          clearSizeDisplay();
        }
      }

      function clearInitialSelection() {
        sizeRadios.forEach(function (radio) {
          radio.checked = false;
          radio.removeAttribute("checked");
        });

        clearSizeDisplay();
        updateButtonState();
      }

      sizeRadios.forEach(function (radio) {
        radio.addEventListener("change", updateButtonState);
      });

      clearInitialSelection();
      setTimeout(clearInitialSelection, 100);
      setTimeout(clearInitialSelection, 300);
    });
  }

  setupSizeGuard();
}

    function updateButtonState() {
      var selectedSize = sizeWrapper.querySelector("[data-single-option-selector]:checked");

      if (selectedSize) {
        setButtonDisabledState(false);
        setButtonText("Add to Basket");
        showSizeDisplay(selectedSize.value);
      } else {
        setButtonDisabledState(true);
        setButtonText("Select a size");
        clearSizeDisplay();
      }
    }

    function clearInitialSelection() {
      sizeRadios.forEach(function (radio) {
        radio.checked = false;
        radio.removeAttribute("checked");
      });

      clearSizeDisplay();
      updateButtonState();
    }

    function initSitewideSalePrices() {
  var priceBlocks = document.querySelectorAll(
    ".product__price:has([data-sitewide-sale-price])"
  );

  priceBlocks.forEach(function (priceBlock) {
    if (priceBlock.dataset.sitewideSaleInitialized === "true") return;
    priceBlock.dataset.sitewideSaleInitialized = "true";

    var productContainer =
      priceBlock.closest(".product__wrapper") ||
      priceBlock.closest(".product-single") ||
      priceBlock.closest(".product-page") ||
      priceBlock.closest(".product-quick-add__content") ||
      priceBlock.closest("[data-product]");

    if (!productContainer) return;

    var variantsScript = priceBlock.querySelector(
      "[data-sitewide-sale-variants]"
    );

    var salePriceElement = priceBlock.querySelector(
      "[data-sitewide-sale-price]"
    );

    var originalPriceElement = priceBlock.querySelector(
      "[data-sitewide-original-price]"
    );

    if (
      !variantsScript ||
      !salePriceElement ||
      !originalPriceElement
    ) {
      return;
    }

    var variants;

    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return;
    }

    var discountPercentage = parseFloat(
      salePriceElement.dataset.sitewideSaleDiscount
    );

    if (isNaN(discountPercentage)) return;

    function formatMoney(cents) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === "function"
      ) {
        return window.Shopify.formatMoney(
          cents,
          window.theme?.moneyFormat || "{{ shop.money_format | escape }}"
        );
      }

      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP"
      }).format(cents / 100);
    }

    function updateSalePrice() {
      window.setTimeout(function () {
        var variantInput = productContainer.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );

        if (!variantInput || !variantInput.value) return;

        var selectedVariant = variants.find(function (variant) {
          return String(variant.id) === String(variantInput.value);
        });

        if (!selectedVariant) return;

        var multiplier = (100 - discountPercentage) / 100;
        var discountedPrice = Math.round(
          selectedVariant.price * multiplier
        );

        salePriceElement.textContent = formatMoney(discountedPrice);
        originalPriceElement.textContent = formatMoney(
          selectedVariant.price
        );
      }, 50);
    }

    productContainer.addEventListener("change", function (event) {
      if (
        event.target.matches(
          "[data-single-option-selector], " +
          'input[name^="options["], ' +
          'select[name^="options["]'
        )
      ) {
        updateSalePrice();
      }
    });

    updateSalePrice();
  });
}

  document.addEventListener("DOMContentLoaded", function () {
    initCollectionSliderArrows();
    initHideSilverOption();
    initMaterialsTabs();
    initSitewideSalePrices();
    initSizeSelectionGuard();

    var quickAddObserver = new MutationObserver(function () {
      setTimeout(function () {
        initSizeSelectionGuard();
      }, 100);
    });

    quickAddObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();